import React from "react";
import { Controller } from "react-hook-form";
import Dropdown2 from "../dropdown2/Dropdown2";
import Creatives2 from "../creatives2/Creatives2";
import DownloadFormat from "../downloadFormat/DownloadFormat";
import Previews from "../previews/Previews";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import SpecsheetButtonBlue from "../../button/specsheetButtonBlue/SpecsheetButtonBlue";
import Keywords2 from "../keywords2/Keywords2";
import SpecsheetButtonWhite from "../../button/specsheetButtonWhite/SpecsheetButtonWhite";
import "./Form2.css";
import Category from "../category/Category";
import Publisher from "../publisher/Publisher";
import Website from "../website/Website";
import Environment from "../environment/Environment";
import Section from "../section/Section";
import Device from "../device/Device";
import Countries2 from "../countries2/Countries2";
import ListSubheader2 from "../listSubheader2/ListSubheader2";

const Form2 = ({
  control,
  register,
  errors,
  showSidebarDownloads,
  showSidebarPreviews,
  sidebarPreviews,
  sidebarDownloads,
  setOverlayActive,
  errorMessage,
  setManageCreatives,
  manageCreatives,
  positionButton,
  setPositionButton,
}) => {
  const options = [
    { label: "Active", value: "active" },
    { label: "Not active", value: "notActive" },
  ];

  // This will show the download section.
  function showDownload() {
    return (
      <div className="download-links-container">
        <div className="download-section">
          <div className="container-title-download">
            <p className="download-template-title">DOWNLOAD TEMPLATE</p>
            <FontAwesomeIcon
              className="download-icon"
              icon={faXmark}
              onClick={showSidebarDownloads}
            />
          </div>
          <div className="download-introduction-container">
            <p>Download this template to your device and start creating</p>
          </div>

          <DownloadFormat
            {...{ control, register, errors, showSidebarDownloads }}
          />
        </div>
      </div>
    );
  }

  // Always display todays date in the form as a placeholder.
  function dateToday() {
    var dateObj = new Date();
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();

    const newdate = day + "-" + month + "-" + year;
    return newdate;
  }

  return (
    <div className="specsheet-editor">
      <div className="sheet-container-top">
        <div className="top-container">
          <div className="extra-container">
            <div className="top-inner-container">
              <div className="inner-divider-block">
                <div className="vertical-divider"></div>
                <div className="specification-sheet-wrapper">
                  <section className="active-wrapper">
                    <div>
                      <Controller
                        control={control}
                        name={`active`}
                        render={({ field: { onChange, value } }) => (
                          <Dropdown2
                            label="Active Template * "
                            options={options}
                            value={value}
                            onChange={onChange}
                            fieldRef={register("active", { required: true })}
                          />
                        )}
                      />
                    </div>
                  </section>
                  <div className="extra-search-options">
                    <SpecsheetButtonBlue
                      type="button"
                      handleClick={showSidebarDownloads}
                    >
                      DOWNLOAD TEMPLATE
                    </SpecsheetButtonBlue>

                    <SpecsheetButtonWhite
                      type="button"
                      handleClick={showSidebarPreviews}
                    >
                      PREVIEW TEMPLATE
                    </SpecsheetButtonWhite>
                  </div>
                </div>

                <div className="title-specsheet-form divider">
                  <Category {...{ control, register, errors }} />
                  <Publisher {...{ control, register, errors }} />
                  <Website {...{ control, register, errors }} />
                  <Environment {...{ control, register, errors }} />
                  <Section {...{ control, register, errors }} />
                  <Device {...{ control, register, errors }} />
                  <InputFieldFormArray
                    label="Template name * "
                    fieldRef={register("templateName", {
                      required: true,
                    })}
                    name="templateName"
                    type="text"
                  />
                  <InputFieldFormArray
                    label="Last Update"
                    fieldRef={register("lastUpdate", {
                      required: false,
                      pattern: {
                        value:
                          /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
                      },
                    })}
                    name="lastUpdate"
                    placeholder={dateToday()}
                    type="text"
                  />

                  <Countries2 {...{ control, register, errors }} />

                  <ListSubheader2 {...{ control, register, errors }} />
                </div>

                <div className="divider">
                  <div>
                    <Keywords2
                      {...{
                        control,
                        register,
                        errors,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="preview-download-container-mobile">
          <div className="top-container">
            <div className="extra-container">
              <div className="top-inner-container">
                <div className="inner-divider-block">
                  <div className="preview-download-inner-container-mobile">
                    <p className="horizontal-divider"></p>

                    <div className="first-button-mobile">
                      <SpecsheetButtonBlue
                        type="button"
                        handleClick={showSidebarDownloads}
                      >
                        DOWNLOAD TEMPLATE
                      </SpecsheetButtonBlue>
                    </div>

                    <p className="horizontal-divider"></p>
                    <p className="horizontal-divider"></p>

                    <div className="second-button-mobile">
                      <SpecsheetButtonWhite
                        type="button"
                        handleClick={showSidebarPreviews}
                      >
                        PREVIEW TEMPLATE
                      </SpecsheetButtonWhite>
                    </div>
                    <p className="horizontal-divider"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          sidebarPreviews ? "preview-slider__active" : "preview-slider"
        }
      >
        <div className="preview-links-container">
          <div className="container-title-download">
            <p className="preview-template-title">PREVIEW TEMPLATE</p>
            <FontAwesomeIcon
              className="download-icon"
              icon={faXmark}
              onClick={showSidebarPreviews}
            />
          </div>

          <div className="preview-container">
            <div className="preview-introduction-container">
              <p>
                Scan QR code or click on the link below to preview the template
              </p>
            </div>

            <p className="template-name"></p>
            <div className="template-tiles-container">
              <Previews {...{ control, register, errors }} />
            </div>
          </div>
          <section className="done-section">
            <SpecsheetButtonWhite
              type="button"
              handleClick={showSidebarPreviews}
            >
              Done
            </SpecsheetButtonWhite>
          </section>
        </div>
      </div>
      <div
        className={
          sidebarDownloads ? "download-slider__active" : "download-slider"
        }
      >
        {showDownload()}
      </div>

      <div className="outer-specification-container-form2">
        <div className="specification-container2">
          <p className="specification-title">SPECIFICATIONS</p>

          <div className="additional-template-info-form">
            <InputFieldFormArray
              label="Additional template info"
              fieldRef={register("additionalTemplateInformation", {
                required: false,
              })}
              name="additionalTemplateInformation"
              type="text"
            />
            <p className="message">
              Only use if specific extra information is needed. Please check
              with sales if needed.
            </p>
          </div>

          <div className="icon-container">
            <div className="icon-container-horizontal"></div>
          </div>
        </div>
        <div className="creative-container-outer-wrapper2">
          <div className="creative-container-form2">
            <h2 className="editor-section-title">Creative specifications</h2>
            <Creatives2
              {...{
                control,
                register,
                errors,
                setOverlayActive,
                setManageCreatives,
                manageCreatives,
                positionButton,
                setPositionButton,
              }}
            />
          </div>
        </div>
      </div>
      {errorMessage && (
        <p className="error">Something went wrong, please try again later.</p>
      )}
    </div>
  );
};

export default Form2;
